/**
 * UserUpdateReq 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'

/**
 * UserUpdateReq
 */
export interface UserUpdateReq {
  /** 用户ID */
  id: string
  /** 昵称 */
  nickname?: string
  /** 性别 */
  gender?: string
  /** 生日 */
  birthday?: any
  /** 个人简介 */
  bio?: any
  /** 国家/地区代码 */
  region?: string
  /** 界面语言区域 */
  locale?: string
  /** 头像文件ID */
  avatar_id?: any
  /** 背景图文件ID */
  background_id?: any
}

/**
 * UserUpdateReq Schema
 */
export const UserUpdateReqSchema: SchemaDefinition = {
  properties: {
    id: {
      description: '用户ID',
      format: 'string',
      type: 'string',
      label: '用户ID',
    },
    nickname: {
      description: '昵称',
      format: '*string',
      type: 'string',
      label: '昵称',
    },
    gender: {
      description: '性别',
      format: '*cons.UserGender',
      type: 'string',
      label: '性别',
    },
    birthday: {
      description: '生日',
      format: '*time.Time',
      type: 'date',
      label: '生日',
    },
    bio: {
      description: '个人简介',
      format: '*string',
      type: 'text',
      label: '个人简介',
    },
    region: {
      description: '国家/地区代码',
      format: '*cons.Region',
      type: 'string',
      label: '国家/地区代码',
    },
    locale: {
      description: '界面语言区域',
      format: '*cons.Locale',
      type: 'string',
      label: '界面语言区域',
    },
    avatar_id: {
      description: '头像文件ID',
      format: '*string',
      type: 'image',
      label: '头像文件ID',
    },
    background_id: {
      description: '背景图文件ID',
      format: '*string',
      type: 'image',
      label: '背景图文件ID',
    },
  },
  required: ['id'],
  type: 'object',
}
